<div class="dialog-container">
  <div class="head-style">
    <h6 mat-dialog-title class="head-size">
      <span class="head-margin">Set Defaults</span>
    </h6>
    <a class="icon-pos" matTooltip="Close" (click)="onNoClick()">
      <mat-icon >close</mat-icon>
    </a>
  </div>

  <div class="content-area">
    <div class="input-field" *ngIf="storeList?.length ">
     <div style="display: flex;"> <label for="store-select">Store</label> &nbsp;
       <label *ngIf="isDefaultSelectionRequired" style="color: red !important;">*</label></div>
      <mat-form-field appearance="outline" id="store-select">
        <mat-select [(ngModel)]="store" required placeholder="Select Store">
          <mat-option>
            <ngx-mat-select-search [formControl]="storeSearch"
              [placeholderLabel]="'RegistrationPage.search' | translate"></ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let stores of filterStore" [value]="stores">
            {{stores.storeDesc}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="input-field" *ngIf="isDefaultCashCounter">
      <label for="store-select">Cash Counter</label>
      <mat-form-field appearance="outline" id="store-select">
        <mat-select [(ngModel)]="cashCounter" required placeholder="Select Cash Counter" [disabled]="isDisabled">
          <mat-option>
            <ngx-mat-select-search [formControl]="cashCounterSearch"
               [placeholderLabel]="'RegistrationPage.search' | translate"></ngx-mat-select-search>
          </mat-option>
          <mat-option>None</mat-option>
          <mat-option *ngIf="cashCounter && cashCounterName" [value]="cashCounter">
            {{ cashCounterName }}
          </mat-option>
          <mat-option *ngFor="let cashCounter of filterCashCounter" [value]="cashCounter">
            {{cashCounter.cashCounterDesc}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="input-field" *ngIf="isWorkStationRequired">
      <label for="store-select">Workstation</label>
      <mat-form-field appearance="outline" id="store-select">
        <mat-select [(ngModel)]="workstation" required placeholder="Select Workstation">
          <mat-option>
            <ngx-mat-select-search [formControl]="workstationSearch"
              placeholder="'RegistrationPage.search' | translate"></ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let data of filterWorkstations" [value]="data">
            {{data.desc}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button mat-mini-fab (click)="onSaveClick()" matTooltip="Save">
    <mat-icon>save</mat-icon>
  </button>
</div>